export default "__VITE_ASSET__Bx8HWESS__"